import axios from 'axios';
import BaseAPI from './base/base-api';

class InternalAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'internal';
}

export default new InternalAPI();